const useTermsCondition = () => {
  const mailToSupport = () => {
    window.open("mailto:Support@CommunaCam.com", "_blank");
  };

  const mailToRadc = () => {
    window.open("mailto:radcliffridgeboard@gmail.com", "_blank");
  };

  const terms = [
    {
      title: "Definitions (Plain-English + Technical)",
      subTitle: "For purposes of these Terms:",
      showBullet: true,
      subPoints: [
        {
          title: (
            <>
              <b>“Board”</b> means the elected Board of Directors of an
              Association.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Owner”</b> means the record owner of a Unit/lot/property in an
              Association and includes the Owner’s Authorized Agent (including a
              Property Manager) when acting on the Owner’s behalf in connection
              with the Software.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Authorized Agent”</b> means a person authorized by an Owner
              (or by law) to act for that Owner, including a property manager,
              attorney-in-fact, trustee, executor/administrator, or other
              verified representative.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Tenant”</b> means a renter/occupant authorized by an Owner or
              the Association/Management Company (as applicable) to access
              certain Software features.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“User” / “You”</b> means any Owner, Authorized Agent, Property
              Manager, Tenant, Director, officer, committee member, volunteer,
              or any other person granted access to the Software.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“E-Communications”</b> means communications delivered
              electronically, including via the Software, email, SMS/text, push
              notifications, electronic portals, and electronic document
              delivery.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Electronic Signature” / “E-Signature”</b> means an electronic
              sound, symbol, or process attached to or logically associated with
              a record and executed or adopted with intent to sign.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Electronic Record”</b> means a contract, authorization,
              notice, disclosure, form, statement, record, or other information
              created, generated, sent, communicated, received, or stored by
              electronic means.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Offshore Service Provider”</b> means a third-party service
              provider located outside the United States that provides support
              or shared services (including technical, administrative,
              accounting, or other operational support) for GGCL and/or the
              Management Company.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Payment Gateway”</b> means any third-party provider used to
              process payments, including ACH, card, wallet, or bank transfer
              services.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Owner Master Data”</b> means the core identity/profile data
              associated with an Owner (and linked accounts), which may be used
              across multiple Associations on the Software.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Software Bugs”</b> means defects, errors, vulnerabilities,
              misconfigurations, or unintended behaviors in the Software
              (including updates) that may affect functionality, security, or
              data.
            </>
          ),
        },
        {
          title: (
            <>
              <b>“Personal Sensitive Information” (or “PSI”)</b> means
              information that identifies, relates to, describes, is reasonably
              capable of being associated with, or could reasonably be linked
              with an individual, and that is sensitive in nature, including but
              not limited to: government identification numbers; financial
              account numbers and payment card data; login credentials
              (usernames/passwords, MFA codes, security questions);
              medical/health information; precise location data; date of birth;
              private contact details not otherwise publicly available; security
              access codes; images/video/audio captured in a context where
              privacy is reasonably expected; and any combination of data
              elements that would enable identity theft, account takeover, or
              unauthorized access to Association systems or records.
            </>
          ),
        },
      ],
    },
    {
      title:
        "Acceptance, Updates, and Agreement to Electronic Use (Required Before Login)",
      subPoints: [
        {
          title: (
            <>
              <b>Mandatory Acceptance Before Login.</b> You must accept these
              Terms before your first login.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Revisions Require Re-Acceptance.</b> If these Terms are
              updated, you must re-accept them to continue using the Software.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Electronic Contract.</b> By clicking “I Agree,” you are signing
              this agreement electronically.
            </>
          ),
        },
        {
          title: (
            <>
              <b>You Can Print / Retain Copies.</b> You will have an option to
              print out and retain a copy of (a) these Terms, and (b) all
              communications you review or sign electronically, including
              notices, forms, disclosures, approvals, confirmations, and
              acknowledgments, subject to your device and software capabilities.
            </>
          ),
        },
      ],
    },
    {
      title: "Who is Covered; Authority; Eligibility",
      subPoints: [
        {
          title: (
            <>
              <b>Covered Users.</b> These Terms apply to all Users, including:
              Owners (including Authorized Agents / Property Managers acting on
              behalf of Owners); Tenants (to the extent granted access);
              Directors, officers, committee members, volunteers, and designees
              acting on behalf of the Board.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Authority Representations.</b> If you act as an Authorized
              Agent / Property Manager, you represent that you have authority to
              act for the Owner and to accept these Terms on the Owner’s behalf
              where applicable.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Role-Based Access.</b> Access features may vary by role (Owner
              vs. Tenant vs. Board) and may be changed or revoked by the
              Association/Board/Management Company administrators.
            </>
          ),
        },
      ],
    },
    {
      title: "Purpose and Permitted Use",
      subPoints: [
        {
          title: (
            <>
              The Software is provided for Association-related communications
              and operations (requests, notices, documents, approvals, payments
              if enabled, etc.).
            </>
          ),
        },
        {
          title: (
            <>
              You agree not to misuse the Software, including: unauthorized
              access attempts; disruption; malware; harassment; illegal content;
              or violations of Association rules or third-party rights.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Accidental Exposure Acknowledgment.</b> In using the Software,
              you acknowledge that accidental exposure of confidential
              information and/or Personal Sensitive Information may occur due to
              Software Bugs, cybersecurity incidents, system misconfigurations,
              service interruptions, user error, third-party failures, or other
              software glitches, including events that may arise from ordinary
              negligence, and you agree to use the Software with appropriate
              caution (including limiting what you upload, verifying recipients,
              and safeguarding any downloaded/printed records). You further
              acknowledge that such risks cannot be entirely eliminated and are
              addressed in the risk allocation, limitations of liability, and
              indemnities in these Terms. error.
            </>
          ),
        },
      ],
    },
    {
      title:
        "E-Communications Policy (Consent, Delivery, Print/Retain, and Records)",
      subPoints: [
        {
          title: (
            <>
              <b>Consent to Receive E-Communications.</b> By accepting these
              Terms and/or enrolling in e-delivery features, you consent to
              receive E-Communications related to Association business,
              including notices, statements, disclosures, approvals, and
              confirmations, unless you withdraw consent as described below.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Delivery Methods;</b> Your Initial Login Responsibilities;
              Conversion Disclaimer. E-Communications may be delivered via the
              Software, email, SMS/text, push notification, or other electronic
              channels you enable. If this is your first time logging in, you
              must review, validate, and confirm that your contact information
              and delivery preferences are correct and that each electronic
              channel is enabled or disabled according to your preference. You
              understand that, during initial onboarding or data migration, some
              contact details and preferences may be populated through initial
              data conversions. The Association, the Management Company, and
              GGCL are not responsible for mistakes, omissions, or inaccuracies
              arising from initial data conversions, legacy records, or
              user-provided information, and you agree to promptly correct and
              update your information and preferences as needed.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Your Ability to Retain. </b> You agree to maintain the ability
              to access and retain Electronic Records. You may print or save a
              copy of communications you view or sign.
            </>
          ),
        },
        {
          title: (
            <>
              When Paper May Still Be Required. Certain documents may be
              required to be delivered in paper form by law or governing
              documents; the Association/Management Company may do so in its
              discretion.
            </>
          ),
        },
      ],
    },
    {
      title: "Electronic Transactions Authorization; E-Signatures",
      subPoints: [
        {
          title: (
            <>
              <b>Authorization to Conduct Electronic Transactions.</b> You
              authorize the Software, GGCL, the Management Company, and the
              Association (as applicable) to present, route, and record
              transactions electronically, including approvals, acknowledgments,
              consents, submissions, ballots (if enabled), and requests.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Binding Effect of E-Signatures.</b> You agree that your
              E-Signature is legally binding to the same extent as a handwritten
              signature, to the maximum extent permitted by applicable law.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Attribution and Intent.</b> You agree that actions taken using
              your credentials (including clicking accept/approve/sign)
              constitute your intent to sign and be bound.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Consent to Electronic Evidence. </b> You agree that Electronic
              Records and audit logs (timestamps, IP/device indicators where
              available, authentication events, and records of consent) may be
              used as evidence of your actions and agreements, subject to
              applicable law.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Payment Authorization (If Enabled). </b> When you initiate a
              payment or authorize recurring payments, you authorize the Payment
              Gateway and relevant parties to process the transaction according
              to the instructions you provide and the gateway’s terms.
            </>
          ),
        },
      ],
    },
    {
      title: "System Requirements (Your Responsibilities)",
      subPoints: [
        {
          title: (
            <>
              <b>A compatible computer or device</b> and operating system
              capable of running the Software and related tools.
            </>
          ),
        },
        {
          title: (
            <>
              <b>An up-to-date internet browser</b> (latest stable version
              recommended) with cookies and TLS/security features enabled.
            </>
          ),
        },
        {
          title: (
            <>
              <b>An up-to-date email management program</b> (email client or
              webmail) if you elect email delivery.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Up-to-date antivirus / anti-malware software</b> (where
              applicable to your device).
            </>
          ),
        },
        {
          title: (
            <>
              A reliable internet connection sufficient to access the Software
              and download/print/save records.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Microsoft Windows users: </b>keep Windows updated with current
              security patches (or equivalent for macOS/iOS/Android).
            </>
          ),
        },
        {
          title: (
            <>
              If you cannot meet these requirements, you should not rely solely
              on electronic delivery and should consider withdrawing consent
              (see Section 8).
            </>
          ),
        },
      ],
    },
    {
      title: "How to Withdraw Your Consent (E-Communications / E-Sign)",
      subPoints: [
        {
          title: (
            <>
              <b>In-App (Preferred):</b> Go to My Profile → Accounting Info /
              Account Preferences and disable E-Com Signup (if available).
            </>
          ),
        },
        {
          title: (
            <>
              <b>Email Request: </b> Send a request to:{" "}
              <b className="cursor-pointer" onClick={mailToRadc}>
                radcliffridgeboard@gmail.com
              </b>{" "}
              and / or{" "}
              <b className="cursor-pointer" onClick={mailToSupport}>
                support@CommunaCam.com
              </b>{" "}
              with subject “Withdraw E-Consent – CommunaCam” and include your
              name, association, property address/unit, and preferred contact
              method.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Written Request:</b> Deliver a written request to the
              Management Company and/or the Association (attention: President
              and/or Secretary) at the contact/address on file, including your
              name, association, property address/unit, the consent you are
              withdrawing (E-Communications and/or E-Signatures), and your
              preferred alternative delivery method.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Effect of Withdrawal.</b> Withdrawal may mean you receive
              notices by paper (where available) and may limit or disable
              certain features. Withdrawal does not invalidate Electronic
              Records or E-Signatures you executed before withdrawal.
            </>
          ),
        },
      ],
    },
    {
      title: "Update Contact Information",
      subPoints: [
        {
          title: (
            <>
              <b>In-App:</b> My Profile → User Info; and/or
            </>
          ),
        },
        {
          title: (
            <>
              <b>
                Email:{" "}
                <span className="cursor-pointer" onClick={mailToRadc}>
                  radcliffridgeboard@gmail.com
                </span>
              </b>{" "}
              (include old and new contact details); and/or
            </>
          ),
        },
        {
          title: (
            <>
              <b>Written Notice:</b>
              Deliver written notice to the Management Company and/or the
              Association (attention: President and/or Secretary) at the
              contact/address on file, including your name, association,
              property address/unit, the information to be updated, and the
              effective date of the change.
            </>
          ),
        },
        {
          title: (
            <>
              You are responsible for keeping your email address, phone number,
              mailing address, and notification preferences current. Failure to
              update may prevent timely receipt of notices.
            </>
          ),
        },
      ],
    },
    {
      title: "Cybersecurity, Data Privacy, and Bugs – Risk Allocation",
      subPoints: [
        {
          title: (
            <>
              <b>No Perfect Security. </b>GGCL and/or the Management Company use
              reasonable measures, but no system is fully secure.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Acknowledged Risks Include Bugs. </b> You acknowledge risks
              from cyberattacks, ransomware, breaches, outages, and Software
              Bugs, including defects that may cause inadvertent exposure,
              corruption, or loss of data.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Limitation for Bugs (Including Negligence). </b> To the maximum
              extent permitted by law, GGCL, the Management Company, and their
              developers/shared service providers are not liable for damages
              arising from Software Bugs, including those resulting from
              ordinary negligence, except to the extent liability cannot be
              disclaimed under applicable Illinois law (and excluding gross
              negligence or willful misconduct where non-disclaimable).
            </>
          ),
        },
        {
          title: (
            <>
              <b>Your Role in Security. </b> You agree to use strong passwords,
              protect credentials, keep devices updated, and promptly report
              suspected compromise.
            </>
          ),
        },
      ],
    },
    {
      title: "Offshore and Shared Service Providers",
      subPoints: [
        {
          title: (
            <>
              GGCL and/or the Management Company may use third-party and/or{" "}
              <b>Offshore Service Providers</b> for support and shared services.
            </>
          ),
        },
        {
          title: (
            <>
              Association data may be accessed/processed from offshore locations
              solely to provide services and support, within controlled systems.
            </>
          ),
        },
        {
          title: (
            <>
              To the maximum extent permitted by law, GGCL and the Management
              Company are not liable for acts/omissions of such providers except
              to the extent caus
            </>
          ),
        },
      ],
    },
    {
      title: "Third-Party Vendors, Integrations, and Payment Gateways",
      subPoints: [
        {
          title: (
            <>
              The Software may link to or integrate with third-party services
              (including Payment Gateways).
            </>
          ),
        },
        {
          title: (
            <>
              Third parties operate under their own terms and privacy policies;
              GGCL/Management Company do not warrant their performance or
              security.
            </>
          ),
        },
        {
          title: (
            <>
              To the maximum extent permitted by law, GGCL/Management Company
              are not liable for third-party failures.
            </>
          ),
        },
      ],
    },
    {
      title: "Confidentiality and Sensitive Information",
      subPoints: [
        {
          title: (
            <>
              Association records, homeowner data, financial information, and
              credentials are confidential/sensitive.
            </>
          ),
        },
        {
          title: (
            <>
              You agree not to disclose or misuse confidential information and
              to safeguard records you download/print/store.
            </>
          ),
        },
      ],
    },
    {
      title:
        "Records, Data Ownership, Cross-Association Master Data, and Retention",
      subPoints: [
        {
          title: (
            <>
              <b>Association Records Ownership. </b>
              Association records remain the property of the Association.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Owner Master Data Shared Across Associations. </b>
              You acknowledge that Owner Master Data may be shared across
              Associations within the Software to support continuity of
              identity/access and operational needs.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Deletion / Retention Rule (Last Association Controls). </b>{" "}
              Owner Master Data will be deleted{" "}
              <b>
                only in accordance with the retention policy of the last
                Association
              </b>
              with which that Owner Master Data is associated (i.e., deletion
              occurs after relationship ends with all Associations and the
              applicable retention period has run).
            </>
          ),
        },
        {
          title: (
            <>
              <b>Post-Termination Deletion Window (30 Days). </b>
              Following termination of the Software/service relationship for an
              Association, GGCL may delete that Association’s data after 30
              days, except for archival records required by law, dispute holds,
              security logs, or other legally required retention.
            </>
          ),
        },
      ],
    },
    {
      title: "User Content; Moderation; Suspension",
      subPoints: [
        {
          title: (
            <>
              Content you upload/post may be processed and displayed to operate
              the Software for Association purposes.
            </>
          ),
        },
        {
          title: (
            <>
              Admins may remove content or suspend/revoke access for violations,
              security reasons, or role/eligibility changes.
            </>
          ),
        },
      ],
    },
    {
      title: "Disclaimers (No Professional Advice; Responsibilities)",
      subPoints: [
        {
          title: (
            <>
              <b>No Professional Advice. </b>
              The Software including AI (Artificial Intelligence) and any
              templates, reminders, messages, dashboards, workflows, summaries,
              or outputs made available through it do not constitute legal,
              accounting, community association management, or property
              management advice, and should not be relied upon as such.
            </>
          ),
        },
        {
          title: (
            <>
              <b>As-Is / As-Available. </b>
              To the maximum extent permitted by law, the Software is provided
              “as is” and “as available, ” without warranties of any kind,
              whether express, implied, or statutory, including warranties of
              merchantability, fitness for a particular purpose,
              non-infringement, or that operation will be uninterrupted or
              error-free.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Licensed Professionals.</b>
              It is the responsibility of the Association and/or the Management
              Company (as determined by their governing documents and contracts)
              to hire and rely upon appropriately licensed and qualified
              professionals when required. GGCL does not provide and is not
              responsible for providing any professional advice and/or services
              (including legal, accounting, community association management, or
              property management services).
            </>
          ),
        },
      ],
    },
    {
      title: "Limitation of Liability",
      subTitle: "To the maximum extent permitted by law:",
      subPoints: [
        {
          title: (
            <>
              <b>No Consequential Damages. </b>GGCL and the Management Company
              will not be liable for consequential, incidental, indirect,
              special, or punitive damages (including loss of data, revenue, or
              reputation).
            </>
          ),
        },
        {
          title: (
            <>
              Additional Limits. Additional caps/limits may apply as allowed by
              law and relevant service arrangements.
            </>
          ),
        },
      ],
    },
    {
      title:
        "Indemnity; Board-Approval Requirement; Access Does Not Grant Distribution Rights; Product Development Events",
      subPoints: [
        {
          title: (
            <>
              <b>Access ≠ Right. </b>Simply because you can view or access
              information in the Software does not mean you have the right to
              download, export, copy, photograph/screenshot, transmit, publish,
              forward, disclose, or otherwise share that information. You may
              use, download, or share Association information only as expressly
              permitted by these Terms, the Association’s governing documents
              and policies, and prior written authorization by the Board when
              required.
            </>
          ),
        },
        {
          title: (
            <>
              <b>No Responsibility for Unapproved Distribution. </b>To the
              maximum extent permitted by law, GGCL, the Association, and the
              Management Company have no responsibility whatsoever for any
              Association data, confidential information, and/or Personal
              Sensitive Information that is downloaded, exported, copied,
              screenshot/recorded, transmitted, published, forwarded, or
              otherwise distributed without prior written approval from the
              Board (or without other lawful authority expressly recognized by
              the Board/Association).
            </>
          ),
        },
        {
          title: (
            <>
              <b>Your Responsibility for Unapproved Actions. </b>
              You are solely responsible and liable for any actions you take (or
              permit to be taken using your account/credentials) without prior
              written approval from the Board, including any unauthorized
              downloading, exporting, copying, recording, or sharing of
              confidential information or Personal Sensitive Information.
            </>
          ),
        },
        {
          title: (
            <>
              <b>
                Product Development / Enhancement Events (Bugs, Errors,
                Testing).
              </b>
              You acknowledge that, in the natural course of software product
              development—including enhancements, updates, maintenance,
              monitoring, and testing—Software Bugs, programming errors,
              configuration issues, or other glitches may occur and could result
              in accidental access, accidental visibility, or accidental
              exposure of certain data. You agree that such events, standing
              alone, are not construed as gross negligence or willful misconduct
              by GGCL, the Management Company, their developers, contractors, or
              service providers.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Indemnity. </b>
              You agree to defend, indemnify, and hold harmless GGCL, the
              Management Company, the Association, and each of their respective
              officers, directors, employees, agents, contractors, offshore
              developers, and shared service providers from and against any and
              all claims, demands, actions, damages, losses, liabilities,
              penalties, fines, costs, and expenses (including reasonable
              attorneys’ fees and costs) arising out of or related to: (a) your
              misuse of the Software; (b) your violation of these Terms,
              applicable law, Association policies, or third-party rights; (c)
              any content you submit, transmit, or make available through the
              Software; (d) unauthorized actions taken using your
              account/credentials (whether or not authorized by you), including
              due to your failure to safeguard access; (e) actions taken without
              proper authority (including acting as an Authorized Agent without
              valid authorization); and/or (f) any download, export, copying,
              screenshot/recording, transmission, publication, forwarding,
              disclosure, or distribution of Association data, confidential
              information, and/or Personal Sensitive Information without prior
              written approval of the Board (or other lawful authority expressly
              recognized by the Board/Association).
            </>
          ),
        },
        {
          title: (
            <>
              <b>Limitations. </b>
              This indemnity does not apply to the extent a claim is finally
              determined to have been caused by the gross negligence or willful
              misconduct of an indemnified party, where such limitation is
              non-waivable under applicable law.
            </>
          ),
        },
        {
          title: (
            <>
              <b>Non-Waiver of Mandatory Rights. </b> Nothing in these Terms
              limits any rights or remedies that cannot be waived under
              applicable Illinois law.
            </>
          ),
        },
      ],
    },
    {
      title: "Governing Law; Venue",
      subPoints: [
        { title: <>Illinois law governs these Terms.</> },
        {
          title: (
            <>
              Any legal action relating to these Terms shall be brought
              exclusively in the state courts located in{" "}
              <b>DuPage County, Illinois,</b> to the extent permitted by law.
            </>
          ),
        },
      ],
    },
    {
      title: "Contact",
      subPoints: [
        {
          title: (
            <>
              Support (GGCL / designee):{" "}
              <b className="cursor-pointer" onClick={mailToSupport}>
                support@CommunaCam.com
              </b>
            </>
          ),
        },
        {
          title: (
            <>
              Association / Management Company Admin:{" "}
              <b className="cursor-pointer" onClick={mailToRadc}>
                radcliffridgeboard@gmail.com
              </b>{" "}
            </>
          ),
        },
      ],
    },
    {
      title: "Clickwrap Acceptance",
      subPoints: [
        {
          title: (
            <>
              By clicking “I Agree” (or by using the Software after being
              presented with these Terms), you agree to be bound by these Terms
              and Conditions.
            </>
          ),
        },
      ],
    },
  ];

  return {
    terms,
  };
};

export default useTermsCondition;
